/** Roles that may see Sage data: it carries vendor cost, COGS and sales $. Enforced server-side. */
export const SAGE_VIEW_ROLES = ['admin', 'pm'];
/** True when any held role may see Sage data. */
export function canViewSage(roles) {
    return roles.some((r) => SAGE_VIEW_ROLES.includes(r));
}
/** The only company the view carries today. Anything else is rejected rather than mixed in. */
export const SAGE_COMPANY_CODE = 'CHADA1';
/** Spreadsheet column keys are `sage.<field>`, so they can never collide with built-ins (`category`) or admin fields (`moq`). */
export const SAGE_COLUMN_PREFIX = 'sage.';
const MONTHS = [0, 1, 2, 3, 4, 5];
/** All 41 view columns, in view order. */
export const SAGE_FIELDS = [
    { key: 'company_code', label: 'Company', type: 'text', tracked: false },
    { key: 'anchor_year', label: 'Anchor year', type: 'int', tracked: false },
    { key: 'anchor_period', label: 'Anchor period', type: 'int', tracked: false },
    { key: 'item_no', label: 'Sage item', type: 'text', tracked: false },
    { key: 'item_description', label: 'Sage description', type: 'text', tracked: true },
    { key: 'upc_code', label: 'Sage UPC', type: 'text', tracked: true },
    { key: 'category', label: 'Sage category', type: 'text', tracked: true },
    { key: 'item_status', label: 'Sage status', type: 'text', tracked: true, defaultVisible: true },
    { key: 'report_group', label: 'Report group', type: 'text', tracked: true },
    { key: 'moq', label: 'MOQ', type: 'number', tracked: true, defaultVisible: true },
    { key: 'vendor_number', label: 'Vendor no.', type: 'text', tracked: true },
    { key: 'vendor_name', label: 'Vendor', type: 'text', tracked: true, defaultVisible: true },
    { key: 'vendor_item_no', label: 'Vendor item no.', type: 'text', tracked: true },
    { key: 'vendor_cost', label: 'Vendor cost', type: 'vendorMoney', tracked: true, defaultVisible: true },
    { key: 'vendor_cost_currency', label: 'Vendor currency', type: 'text', tracked: true },
    { key: 'qty_on_hand', label: 'On hand', type: 'number', tracked: true, defaultVisible: true },
    { key: 'qty_on_po', label: 'On PO', type: 'number', tracked: true },
    { key: 'qty_on_so', label: 'On SO', type: 'number', tracked: true },
    { key: 'qty_available', label: 'Available', type: 'number', tracked: true, defaultVisible: true },
    { key: 'inventory_value', label: 'Inventory value', type: 'money', tracked: true },
    ...MONTHS.map((i) => ({ key: `month_${i}_label`, label: `Month ${i} (YYYYMM)`, type: 'int', tracked: false })),
    ...MONTHS.map((i) => ({ key: `units_m${i}`, label: `Units month ${i}`, type: 'number', tracked: false })),
    { key: 'units_6m_avg', label: 'Units 6-mo avg', type: 'number', tracked: false, defaultVisible: true },
    ...MONTHS.map((i) => ({ key: `sales_amt_m${i}`, label: `Sales month ${i}`, type: 'money', tracked: false })),
    { key: 'sales_amt_6m_total', label: 'Sales 6-mo total', type: 'money', tracked: false, defaultVisible: true },
    { key: 'cogs_6m_total', label: 'COGS 6-mo total', type: 'money', tracked: false },
];
export const SAGE_FIELD_KEYS = SAGE_FIELDS.map((f) => f.key);
export const SAGE_TRACKED_KEYS = SAGE_FIELDS.filter((f) => f.tracked).map((f) => f.key);
//# sourceMappingURL=sage.types.js.map